import React, { useState, useRef, useEffect } from "react"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import TextBundle from "aldoo-ra/CMS/text-bundle"
import { ChevronRightIcon } from "@heroicons/react/24/outline"
import Input from "aldoo-ra/Input"

export default function ShoppingCartFooter({ store }) {
  const texts = TextBundle({ id: "aldoo-store" })
  const [showPromoInput, setShowPromoInput] = useState(false)
  const promoInputRef = useRef(null)

  const {
    setPromoCode,
    setPromoCodeError,
    promoCode,
    getCartTotalValue,
    beginCheckout,
    applyPromoCode,
    promoCodeError,
    getPromoCodeInfo,
    resetPromoCode,
  } = store

  useEffect(() => {
    if (showPromoInput && promoInputRef.current) {
      promoInputRef.current.focus()
    }
  }, [showPromoInput])

  return (
      <div className="w-full flex flex-col pt-4 border-t border-bordered px-5 sm:px-6 pb-4 pb-[calc(1rem+env(safe-area-inset-bottom))] md:pb-4">
        {/* Total */}
        <div className="w-full flex items-baseline justify-between gap-4 mb-6">
          <Typography variant="body1_accent" className="text-text my-0">
            {texts?.total || "Estimated Total"}:
          </Typography>
          <Typography variant="h3" className="text-text my-0">
            {getCartTotalValue()}
          </Typography>
        </div>

        {/* Discount info */}
        {getPromoCodeInfo() && promoCode && (
          <Typography variant="txt_accent" className="my-0 mb-3 text-success">
            {texts?.discount_label} {getPromoCodeInfo()}
          </Typography>
        )}

        {/* Promo Code */}
        <div className="w-full flex flex-col pb-6">
          {!showPromoInput ? (
            <button
              className="text-primary text-left underline hover:opacity-70 transition-opacity text-sm"
              onClick={() => setShowPromoInput(true)}
            >
              {texts?.have_promocode || "Have a promo code?"}
            </button>
          ) : (
            <div className="flex flex-row items-center gap-3">
              <Input
                ref={promoInputRef}
                className="flex-1"
                showClearButton
                placeholder={texts?.promo_code_placeholder || "Enter a promo code"}
                value={promoCode}
                onClear={resetPromoCode}
                onChange={(e) => {
                  setPromoCodeError(null)
                  setPromoCode(e.target.value.toUpperCase())
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") applyPromoCode()
                }}
              />
              <Button variant="secondary" className="shrink-0" onClick={applyPromoCode}>
                {texts?.apply || "Apply"}
              </Button>
            </div>
          )}

          {promoCodeError && (
            <Typography variant="txt_dim" className="mt-1 text-error">
              {texts?.[promoCodeError] || promoCodeError}
            </Typography>
          )}
        </div>

        <Button
          variant="primary"
          className="w-full !h-auto py-4"
          onClick={() => beginCheckout()}
        >
          {texts?.checkout}
          <ChevronRightIcon className="ml-2 w-5 h-5" />
        </Button>
      </div>
  )
}
